/**
 * @fileoverview GET handler for the "/engagement/campaigns/campaigns_with_replied_to_sms" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCampaignsWithRepliedToSms } from "./constants";
import type { EngagementCampaignsCampaignsWithRepliedToSmsResult } from "./types";

export const getEngagementCampaignsCampaignsWithRepliedToSms = reactQueryFetcherAdapter(
  engagementCampaignsCampaignsWithRepliedToSms,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number
  ): Promise<EngagementCampaignsCampaignsWithRepliedToSmsResult[]> => {
    return fetch(
      "/engagement/campaigns/campaigns_with_replied_to_sms",
      "GET",
      { app_group_id: appGroupId, query, limit },
      { signal }
    );
  }
);
